import "./caseStudyStyles.css";
import brush from "./brush.svg";
import piece10 from "./offmeta.png";
import piece17 from "./banner.png";
import emailicon from "./email-icon.svg";
import hands from "./star.svg";
import share from "./zap.svg";
import star from "./shield.svg";
// import animationData from "./Scene.mp4";
import Header from "./Header";
import piece8 from "./off1.png";
import piece20 from "./1main.png";
import piece21 from "./3main.png";
import piece22 from "./4main.png";
import piece23 from "./6main.png";
import piece24 from "./7main.png";
import piece25 from "./2main.png";
import piece26 from "./9main.png";
import piece27 from "./8main.png";
import piece28 from "./5main.png";
import piece29 from "./10main.png";
import piece30 from "./mob1.png";
import piece31 from "./mob2.png";
import piece32 from "./mob3.png";
import piece33 from "./mob4.png";
import piece34 from "./mob5.png";
import piece35 from "./mob6.png";
import piece36 from "./mob7.png";
import piece37 from "./mob8.png";
import piece38 from "./mob9.png";
import piece39 from "./mob10.png";

export default function CaseStudy2() {
  return (
    <div class="case-study-page">
      <Header />
      {/* <!-- HERO --> */}
      <section class="hero-section">
        <div class="hero-inner">
          <div class="hero-top">
            <div class="hero-icon">
              <img src={brush} alt="" style={{ color: "white" }} />
            </div>

            <div class="hero-badge">
              <span>LIVE</span>
            </div>
          </div>

          <div class="hero-content">
            <h2 style={{ fontSize: "40px" }}>OffMeta Fantasy Product Design</h2>

            <p class="hero-subtitle">An interactive unique fantasy team building application for Esports</p>

            <p class="hero-description">
              Founder of OffMeta Fantasy, an esports fantasy platform where fans draft and compete with their favorite professional players across
              major titles. Beyond traditional fantasy mechanics, I built systems for player progression, strategic boosts, live stat-driven scoring,
              and social competition features designed specifically for the esports audience.
            </p>

            <div class="hero-actions">
              <a href="https://offmetafantasy.com/">
                Live Website
                <span>↗</span>
              </a>
            </div>
          </div>
          <div class="hero-preview">
            <div class="preview-frame">
              <img
                src={piece10}
                alt="Jason Azevedo LinkedIn"
                style={{ borderRadius: "10px", width: "100%", height: "100%", zIndex: "10", position: "relative" }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* <!-- PROJECT META --> */}
      <section class="project-meta">
        <div class="meta-grid">
          <div class="meta-item">
            <span class="meta-label">Product</span>
            <p>Desktop</p>
            <p>Mobile</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">My role</span>
            <p>Product Research & Designer</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Timeline</span>
            <p>Jun 2025 - Present</p>
          </div>

          <div class="meta-item">
            <span class="meta-label">Skills</span>
            <p>Product design, Market Research, Interactive prototyping, User research, Competitor Analysis</p>
          </div>
        </div>

        <div class="team-row">
          <span class="meta-label">Team</span>

          <p>Jason Azevedo</p>
        </div>
      </section>

      {/* <!-- QUOTE IMAGE --> */}
      <section class="quote-banner">
        <div class="quote-image" style={{ height: "auto" }}>
          <img src={piece17} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />

          {/* <div class="quote-overlay">
            <h2>
              "Handing someone your phone
              <br />
              feel like handing over your whole diary..."
            </h2>
          </div> */}
        </div>
      </section>

      {/* <!-- PROBLEM --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Problem: Promoting youth gambling.</h2>
        </div>

        <div class="section-content">
          <p>
            Gambling is a serious issue in the esports market. It serves as the primary source of income for an industry that fails to capitalize on
            it's <b>$3.6 billion</b> market and bridge a meaningful connection with it's fans.
          </p>

          <p>
            Bettors aged 18–27 accounted for <b>44% of all esports gambling activity in 2024</b>, up from 36% the year prior.
          </p>

          <p>
            The data shows the demand for fan engagement is real, but the platforms capitalizing on it are pushing a generation of young viewers
            toward gambling.
          </p>
        </div>
      </section>

      {/* <!-- RESEARCH --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Research</h2>
        </div>

        <div class="section-content">
          <p style={{ margin: "0" }}>
            In the early stages of the project, I interview and surveyed over 40-50 participants to understand the need for an esports management
            platform that actively rewards super fans for their knowledge while allowing casuals to collect a 'piece' of their favorite superstar.
          </p>

          <div class="research-points">
            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Fans lack a low-stakes entry point to a management platform</h3>

              <p>
                The majority of participants expressed interest in engaging with esports competitively but felt excluded by platforms that required
                real-money investment or deep game knowledge to participate.
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Getting their knowledge rewarded</h3>

              <p>
                Highly engaged participants are a crucial piece to any platform. They follow rosters, track stats, and are extremely invested in the
                scene. These fans deserve to get rewarded for their knowledge while actively adding a competitive layer to our platform that opens up
                a variery of engagement features (leaderboard,ranks,etc.).
              </p>
            </div>

            <div class="research-item">
              <h3 style={{ color: "rgb(152, 192, 239)" }}>Collectibles drive emotional investment</h3>

              <p>
                Ownership creates identity. Participants responded strongly to the idea of collecting/earning limited card designs of their favorite
                player. Unlike one-time betting, collectibles give users something to build, show off limited cards, and return to.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- SOLUTION --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Solution: A fantasy platform with no regrets</h2>
        </div>

        <div class="section-content">
          <p>
            The research made one thing clear, esports fans wanted a skill-based, rewarding way to engage with the scene they loved, without being
            funneled into gambling and all the downsides that come with it.
          </p>

          <p>
            The goal was to build something with the emotional pull of card collecting, the strategic depth of traditional fantasy sports, and the
            accessibility of a mobile-first product, all powered by real-time match data that turns esports knowledge into a genuine competitive edge.
          </p>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div class="feature-grid">
              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Player Collectible Card System</p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Live Match Data Integration</p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Skill-Based Team Management</p>
              </div>

              <div class="feature-card">
                {/* <div class="feature-icon">
                  <img src={emailicon} alt="Jason Azevedo LinkedIn" style={{ objectFit: "contain" }} />
                </div> */}

                <p>Casual-Friendly Onboarding</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- FEATURE BLOCKS --> */}
      <section class="feature-sections">
        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={emailicon} alt="OffMeta Fantasy" style={{ objectFit: "contain" }} />
            </div>
            <h3>Designing for the casual fan first.</h3>
          </div>
          <div class="feature-copy">
            <p>
              From the beginning the goal was to intended to be and designed around the idea that a fan could love esports without knowing a every
              single stat or watching every game.
            </p>
            <p>
              The onboarding flow was stripped down to three decisions: pick your players, pick a strategy and start competing. No steep learning
              curve.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={hands} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "22px" }} />
            </div>
            <h3>Building emotional ownership through collectibles.</h3>
          </div>
          <div class="feature-copy">
            <p>
              The collectible card system was the emotional core of the product. Eeach player card was designed to feel rare, personal, and worth
              holding onto. These are decided based on special player performances that one might want to look back at or hold as a piece of
              collection.
            </p>
            <p>
              Scarcity, player performance ratings, and visual rarity tiers were built into the card system to trigger the same ownership feeling that
              makes physical collectibles so compelling.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={share} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "23px" }} />
            </div>
            <h3>Rewarding knowledge with real match data.</h3>
          </div>
          <div class="feature-copy">
            <p>
              Super fans are the core piece of this platform, they are what keeps us running. They analyze, track player form, follow roster swaps,
              and predict outcomes before the casters do. OffMeta Fantasy was built to reward exactly that.
            </p>
            <p>
              By integrating live match data directly into the scoring system, team management decisions carry real weight. A user who knew a specific
              player would have a good game would be rewarded for it; Turning esports knowledge into a genuine competitive advantage.
            </p>
          </div>
        </div>

        <div class="feature-section">
          <div class="feature-heading">
            <div class="feature-icon">
              <img src={star} alt="OffMeta Fantasy" style={{ objectFit: "contain", height: "21px" }} />
            </div>
            <h3>Creating a safe alternative to gambling.</h3>
          </div>
          <div class="feature-copy">
            <p>
              Circling back to our main pain point, esports betting platforms aggressively targeting young audiences, OffMeta Fantasy was
              intentionally designed with no real-money wagering, no paywalled competition, and no dark patterns nudging users toward financial risk.
            </p>
            <p>
              The platform competes on skill and knowledge. That distinction was surfaced clearly throughout the product, from the landing page
              messaging to the competition structure and collectibles.
            </p>
          </div>
        </div>
      </section>

      {/* <!-- DEVICE SHOWCASE --> */}
      <section class="device-showcase">
        <div class="device-frame">
          <img src={piece8} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece20} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece25} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece21} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece22} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece28} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece23} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece24} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece27} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece26} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        <div class="device-frame" style={{ height: "auto" }}>
          <img src={piece29} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative" }} />
        </div>
        {/* <div class="device-caption">
          <p>Private space hides itself automatically when it locks.</p>
        </div> */}
      </section>

      {/* <!-- IMPACT --> */}
      <section class="impact-section">
        <div class="impact-content">
          <div class="section-header">
            <h2>Impact: A New Lane in a Billion-Dollar Market</h2>
          </div>

          <div class="section-content">
            <p>
              OffMeta Fantasy set out to be a fantasy management platform for a generation of fans who just wanted to play while staying away from a
              gambling addiction. Managing your favorite players is a dream of any sports fan.
            </p>

            <p>
              By combining player collectibles, live match data, and skill-based team management into a single platform, OffMeta Fantasy created
              something that didn't exist before. This is our take of a legitimate, low-stakes entry point into the{" "}
              <b>$3.6 billion esports ecosystem</b> and <b>640 million</b> fans worldwide.
            </p>

            <p>
              Research across <b>40+ participants</b> validated the core thesis: Fans felt excluded by existing platforms and nearly everyone
              expressed discomfort with the gambling-first model dominating the space.
            </p>

            <p>
              As the sole founder, full-stack developer, and product researcher, taking this from an insight to a shipped product a milestone in my
              career that boosted my knowledge of the field and confidence to turn an idea into a product.
            </p>

            {/* <div class="hero-actions">
              <a href="/">
                Google Blog
                <span>↗</span>
              </a>
            </div> */}
          </div>
        </div>
      </section>

      {/* <!-- RESEARCH --> */}
      <section class="content-section">
        <div class="section-header">
          <h2>Extra: Mobile Design</h2>
        </div>

        <div class="section-content">
          <p style={{ margin: "0" }}>
            The mobile responsiveness of this application was extremely challenging to work with but super fun. The goal was to essentially translate
            a beautiful desktop dashboard packed with data and analytics into a mobile screen only a few hundred pixels wide.
          </p>

          <p style={{ margin: "16px 0" }}>
            Rather than simply stacking desktop components on top of one another, I rethought the experience from a mobile-first perspective.
            Information was prioritized based on user needs, complex data visualizations were simplified, and navigation patterns were redesigned to
            reduce cognitive load. Throughout the process, I focused on maintaining the depth of the desktop experience while ensuring interactions
            remained fast, intuitive, and accessible on smaller screens.
          </p>

          <p style={{ margin: "16px 0 0" }}>
            The result was a responsive experience that preserved the application's powerful analytics capabilities without overwhelming users,
            allowing them to access critical insights and complete key tasks seamlessly across any device.
          </p>

          {/* <!-- DEVICE SHOWCASE --> */}
          <section class="device-showcase" style={{marginBottom: "160px"}}>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece30} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%" }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece31} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"   }}>
              <img src={piece32} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece33} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece34} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%" }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece35} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"  }}>
              <img src={piece36} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"   }}>
              <img src={piece37} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"   }}>
              <img src={piece38} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
            <div class="device-frame" style={{ height: "900px", background: "#05060f"   }}>
              <img src={piece39} alt="Jason Azevedo LinkedIn" style={{ borderRadius: "10px", width: "100%", zIndex: "10", position: "relative", height: "100%"  }} />
            </div>
          </section>
        </div>
      </section>
    </div>
  );
}
